import { LogoPersonalitec } from '@persona/ui';

/** Persona ERP com a marca Personalitec (topo e login). */
export function Marca({ compacta = false }: { compacta?: boolean }) {
  return (
    <span className="marca" aria-label="Persona ERP — Personalitec">
      <LogoPersonalitec tamanho={compacta ? 24 : 30} />
      {!compacta && <span className="marca-nome">Persona <span className="texto-2">ERP</span></span>}
    </span>
  );
}
